import React, { Component } from 'react';
import './App.css';
import {connect} from 'react-redux'
import {compose} from 'redux'
import { DragDropContext } from 'react-dnd'
import HTML5Backend from 'react-dnd-html5-backend'


class App extends Component {
  render() {
    return (
      <div >
        {this.props.children}
      </div>
    );
  }
}

//export default App;

export default App = compose(connect(
  (state) => ({messages: {}}),null,null,{withRef:true}
),DragDropContext(HTML5Backend))(App);



// WEBPACK FOOTER //
// ./src/App.js